/* ALZARÉ® — interacciones de la página de producto */
(function () {
  'use strict';

  /* ---------- Galería ---------- */
  var track = document.querySelector('[data-gallery-track]');
  if (track) {
    var slides = track.children.length;
    var idx = 0;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    function go(i) {
      idx = (i + slides) % slides;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      var active = thumbs[idx];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    document.querySelectorAll('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { go(idx - 1); }); });
    document.querySelectorAll('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { go(idx + 1); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    /* swipe */
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  /* ---------- Bundle selector ---------- */
  var opts = Array.prototype.slice.call(document.querySelectorAll('.bundle-opt'));
  var atc = document.getElementById('atc-btn');
  var variantInput = document.getElementById('atc-variant');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyCompare = document.querySelector('[data-sticky-compare]');
  function selectOpt(o) {
    opts.forEach(function (x) { x.classList.toggle('is-selected', x === o); });
    var r = o.querySelector('input'); if (r) r.checked = true;
    if (variantInput) variantInput.value = o.getAttribute('data-variant');
    if (atc) { var priceEl = atc.querySelector('[data-atc-price]'); if (priceEl) priceEl.textContent = o.getAttribute('data-price'); }
    if (stickyPrice) stickyPrice.textContent = o.getAttribute('data-price');
    if (stickyCompare) stickyCompare.textContent = o.getAttribute('data-compare');
  }
  opts.forEach(function (o) { o.addEventListener('click', function () { selectOpt(o); }); });
  var preselected = document.querySelector('.bundle-opt.is-selected') || opts[0];
  if (preselected) selectOpt(preselected);

  /* ---------- Add to cart (AJAX) ---------- */
  var form = document.getElementById('atc-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value) { form.submit(); return; }
      atc.disabled = true;
      var original = atc.innerHTML;
      atc.innerHTML = 'Agregando…';
      var items = [{ id: parseInt(variantInput.value, 10), quantity: 1 }];
      var bump = document.getElementById('bump-check');
      if (bump && bump.checked) items.push({ id: parseInt(bump.getAttribute('data-bump-id'), 10), quantity: 1 });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        atc.disabled = false;
        atc.innerHTML = original;
        window.AlzareCart.open(true);
      }).catch(function () {
        atc.disabled = false;
        atc.innerHTML = original;
        window.location.href = '/cart/add?id=' + variantInput.value + '&quantity=1';
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  window.AlzareCart = { open: function () {} };
  if (drawer) {
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var saveRow = drawer.querySelector('[data-cart-savings-row]');
    var saveEl = drawer.querySelector('[data-cart-savings]');
    var timerEl = drawer.querySelector('[data-cart-timer]');
    var busy = false;

    /* mapa variante -> precio "antes" (compare-at) en centavos, desde las cards del bundle */
    var compareMap = {};
    opts.forEach(function (o) {
      var vid = o.getAttribute('data-variant');
      var cc = parseInt(o.getAttribute('data-compare-cents'), 10);
      var pc = parseInt(o.getAttribute('data-cents'), 10);
      if (vid && cc && pc && cc > pc) compareMap[vid] = cc;
    });

    function money(cents) {
      var v = (cents / 100).toFixed(2).split('.');
      return '$' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    }

    function render(cart) {
      var count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="cart-drawer__empty">Tu carrito está vacío.</p>';
        footEl.hidden = true;
        return;
      }
      footEl.hidden = false;
      var savings = 0;
      var html = cart.items.map(function (it) {
        var cmp = compareMap[String(it.variant_id)];
        var lineCmp = cmp ? cmp * it.quantity : 0;
        var saved = lineCmp > it.final_line_price ? lineCmp - it.final_line_price : 0;
        savings += saved;
        var unitCmp = cmp && cmp > it.final_price ? '<s>' + money(cmp) + '</s> ' : '';
        return '<div class="cd-item" data-key="' + it.key + '">' +
          (it.image ? '<img class="cd-item__img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="">' : '<span class="cd-item__img"></span>') +
          '<div class="cd-item__mid">' +
            '<p class="cd-item__title">' + it.product_title + '</p>' +
            '<p class="cd-item__unit">' + unitCmp + '<b>' + money(it.final_price) + '</b></p>' +
            (it.variant_title ? '<span class="cd-item__tag">🏷 ' + it.variant_title + '</span>' : '') +
            '<div class="cd-item__qty"><button type="button" data-qty="-1" aria-label="Menos">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Más">+</button></div>' +
          '</div>' +
          '<div class="cd-item__right">' +
            '<button type="button" class="cd-item__del" data-del aria-label="Quitar"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg></button>' +
            (saved ? '<s class="cd-item__linecmp">' + money(lineCmp) + '</s>' : '') +
            '<b class="cd-item__line">' + money(it.final_line_price) + '</b>' +
            (saved ? '<span class="cd-item__saved">(Te Ahorraste ' + money(saved).replace(',00', '') + ')</span>' : '') +
          '</div>' +
        '</div>';
      }).join('');
      itemsEl.innerHTML = html;
      subEl.textContent = money(cart.total_price);
      if (savings > 0) { saveRow.hidden = false; saveEl.textContent = '−' + money(savings); }
      else saveRow.hidden = true;
    }

    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
    }

    function change(key, qty) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { busy = false; render(c); })
        .catch(function () { busy = false; refresh(); });
    }

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cd-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        var cur = parseInt(row.querySelector('.cd-item__qty span').textContent, 10);
        change(key, Math.max(0, cur + parseInt(qtyBtn.getAttribute('data-qty'), 10)));
      } else if (e.target.closest('[data-del]')) {
        change(key, 0);
      }
    });

    /* timer de reserva (5 min, persiste mientras dura la sesión) */
    var timerInt;
    function startTimer(reset) {
      var dl = parseInt(sessionStorage.getItem('alz_cart_dl') || '0', 10);
      var now = Date.now();
      if (reset || !dl || dl < now) { dl = now + 300000; sessionStorage.setItem('alz_cart_dl', String(dl)); }
      clearInterval(timerInt);
      function tick() {
        var s = Math.floor((dl - Date.now()) / 1000);
        if (s <= 0) { dl = Date.now() + 300000; sessionStorage.setItem('alz_cart_dl', String(dl)); s = 300; }
        timerEl.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      }
      tick(); timerInt = setInterval(tick, 1000);
    }

    function openDrawer(resetTimer) {
      refresh().then(function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        startTimer(!!resetTimer);
      });
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      clearInterval(timerInt);
    }
    window.AlzareCart.open = openDrawer;
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(false); });
    });
  }

  /* ---------- Countdown (oferta del día, reinicia a medianoche) ---------- */
  var timer = document.querySelector('[data-countdown]');
  if (timer) {
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(23, 59, 59, 999);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = String(Math.floor(s / 3600)).padStart(2, '0');
      var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      var sec = String(s % 60).padStart(2, '0');
      timer.textContent = h + ':' + m + ':' + sec;
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Acordeones ---------- */
  document.querySelectorAll('.accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.parentElement.classList.toggle('is-open');
    });
  });

  /* ---------- Timeline ---------- */
  var steps = Array.prototype.slice.call(document.querySelectorAll('[data-timeline-step]'));
  var dots = Array.prototype.slice.call(document.querySelectorAll('[data-timeline-day]'));
  if (dots.length) {
    var ti = 0, auto;
    function showStep(i) {
      ti = i;
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k <= i); });
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { showStep(k); clearInterval(auto); });
    });
    showStep(0);
    auto = setInterval(function () { showStep((ti + 1) % steps.length); }, 4200);
  }

  /* ---------- Read more (testimonios) ---------- */
  document.querySelectorAll('.read-more').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = b.previousElementSibling;
      var full = b.getAttribute('data-full');
      if (p && full) { p.textContent = full; b.remove(); }
    });
  });

  /* ---------- Antes / Después slider ---------- */
  var ba = document.querySelector('[data-ba]');
  if (ba) {
    var after = ba.querySelector('.ba__after');
    var handle = ba.querySelector('.ba__handle');
    function setBA(clientX) {
      var r = ba.getBoundingClientRect();
      var p = Math.min(Math.max((clientX - r.left) / r.width, 0.05), 0.95) * 100;
      after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      handle.style.left = p + '%';
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function (e) { dragging = true; setBA(e.clientX); ba.setPointerCapture(e.pointerId); });
    ba.addEventListener('pointermove', function (e) { if (dragging) setBA(e.clientX); });
    ba.addEventListener('pointerup', function () { dragging = false; });
  }

  /* ---------- Rings animados ---------- */
  var rings = document.querySelectorAll('.ring .fg');
  if (rings.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var c = en.target;
          var pct = parseFloat(c.getAttribute('data-pct')) / 100;
          var len = 2 * Math.PI * 52;
          c.style.transition = 'stroke-dashoffset 1.2s ease';
          c.style.strokeDashoffset = String(len * (1 - pct));
          io.unobserve(c);
        }
      });
    }, { threshold: 0.4 });
    rings.forEach(function (c) {
      var len = 2 * Math.PI * 52;
      c.style.strokeDasharray = String(len);
      c.style.strokeDashoffset = String(len);
      io.observe(c);
    });
  }

  /* ---------- Sticky ATC móvil ---------- */
  var sticky = document.querySelector('.sticky-atc');
  var buyBox = document.getElementById('oferta');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.innerWidth < 900);
    }, { threshold: 0 }).observe(buyBox);
    sticky.querySelector('button').addEventListener('click', function () {
      buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();

/* ---------- Ingredientes: carrusel horizontal ---------- */
(function () {
  'use strict';
  var grid = document.querySelector('#ingredientes .ing-grid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.children);
  if (cards.length < 2) return;

  /* CSS del carrusel (inyectado para no tocar los .css del tema) */
  var css = document.createElement('style');
  css.textContent =
    '#ingredientes .ing-grid{display:flex!important;grid-template-columns:none!important;overflow-x:auto;scroll-snap-type:x mandatory;gap:16px;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;padding:6px 4px 14px;scrollbar-width:none}' +
    '#ingredientes .ing-grid::-webkit-scrollbar{display:none}' +
    '#ingredientes .ing-grid>*{flex:0 0 310px;min-width:0;scroll-snap-align:start}' +
    '@media(max-width:640px){#ingredientes .ing-grid>*{flex:0 0 78%}}' +
    '#ingredientes .ing-wrap{position:relative}' +
    '#ingredientes .ing-nav{position:absolute;top:40%;transform:translateY(-50%);z-index:2;width:42px;height:42px;border-radius:50%;border:1px solid #e2ddd8;background:#fff;color:#1a1a1a;font-size:24px;line-height:1;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.14);display:flex;align-items:center;justify-content:center;transition:opacity .2s}' +
    '#ingredientes .ing-nav--prev{left:-8px}#ingredientes .ing-nav--next{right:-8px}' +
    '@media(max-width:640px){#ingredientes .ing-nav{display:none}}' +
    '#ingredientes .ing-dots{display:flex;gap:7px;justify-content:center;margin-top:12px}' +
    '#ingredientes .ing-dots span{width:8px;height:8px;border-radius:50%;background:#ddd6cf;transition:background .2s,transform .2s}' +
    '#ingredientes .ing-dots span.is-on{background:var(--accent,#1d4d41);transform:scale(1.25)}';
  document.head.appendChild(css);

  /* Estructura: wrapper + flechas + dots */
  var wrap = document.createElement('div');
  wrap.className = 'ing-wrap';
  grid.parentNode.insertBefore(wrap, grid);
  wrap.appendChild(grid);
  var prev = document.createElement('button');
  prev.type = 'button'; prev.className = 'ing-nav ing-nav--prev'; prev.setAttribute('aria-label', 'Anterior'); prev.textContent = '‹';
  var next = document.createElement('button');
  next.type = 'button'; next.className = 'ing-nav ing-nav--next'; next.setAttribute('aria-label', 'Siguiente'); next.textContent = '›';
  wrap.appendChild(prev); wrap.appendChild(next);
  var dotsEl = document.createElement('div');
  dotsEl.className = 'ing-dots';
  cards.forEach(function () { dotsEl.appendChild(document.createElement('span')); });
  wrap.parentNode.insertBefore(dotsEl, wrap.nextSibling);

  function step() { return cards[0].getBoundingClientRect().width + 16; }
  prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });

  function upd() {
    var i = Math.round(grid.scrollLeft / step());
    i = Math.max(0, Math.min(cards.length - 1, i));
    Array.prototype.forEach.call(dotsEl.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    prev.style.opacity = grid.scrollLeft <= 4 ? '.35' : '1';
    next.style.opacity = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4 ? '.35' : '1';
  }
  grid.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
  window.addEventListener('resize', upd);
  upd();
})();
